
<template>
    <div class="">
      <Menu as="div" class="relative inline-block text-left">
        <div>
          <MenuButton
            class="flex"
          >
            <slot name="label"></slot>
            <ChevronDownIcon
              class="ml-2 -mr-1 h-5 w-5 text-violet-200"
              aria-hidden="true"
            />
          </MenuButton>
        </div>
  
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <MenuItems
            class="absolute left-0 mt-2 w-max origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 max-h-[36rem] focus:outline-none overflow-auto z-30"
          >
          <div v-for="link in filteredLinks" :key="link.href" class="px-1 py-1 w-full bg-white">
            <MenuItem v-slot="{ active, close }"  as="div">
              <NavLink
                :link="{ path: link.href, label: link.label, displayLabel: true }"
                class="max-w-fit"
                :class="[active ? 'bg-dark-primary text-white' : 'text-gray-900', 'rounded-md px-2 py-2 text-sm  w-full flex-nowrap']"
                @click="close"
                @track-link-selection="trackLinkSelection"
              />
            </MenuItem>
          </div>
          <div class="w-full" v-if="linkGroups && linkGroups.length > 0">
            <div class="w-full" v-for="group in linkGroups" :key="group.groupName">
              <div class="w-full">
                <div class="w-full p-1">
                  <div class="text-sm w-full text-gray-400">{{ group.groupName }}</div>
                </div>       
                <div v-for="link in filteredGroupLinks(group.links)" :key="link.href" class="px-1 py-1 w-full bg-white">
                  <MenuItem v-slot="{ active, close }" as="div">
                    <NavLink
                      :link="{ path: link.href, label: link.label, displayLabel: true }"
                      class="max-w-fit"
                      :class="[active ? 'bg-dark-primary text-white' : 'text-gray-900', 'rounded-md px-2 py-2 text-sm  w-full flex-nowrap']"
                      @click="close"
                      @track-link-selection="trackLinkSelection"
                    />
                  </MenuItem>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full" v-if="publicConfigs.length > 0">
            
            <div class="w-full">
              <div class="w-full p-1">
                <div class="text-sm w-full text-gray-400">Public Pages</div>
              </div>
              <div v-for="config in publicConfigs" :key="config.id" class="px-1 py-1 w-full">
                <MenuItem   v-slot="{ active }" as="div">
                  <div class="flex justify-between w-full items-center">
                    <button class="flex justify-start w-full flex-nowrap" @click="setPageConfig(config)"
                      :class="[
                        active  ? 'bg-dark-primary text-white' : isSelectedConfig(config) ? 'bg-dark-primary text-white' : 'text-gray-900',
                        'rounded-md px-2 py-2 text-sm  w-full flex-nowrap '
                      ]" 
    
                    >
                      {{config.configuration_name}}
                    </button>
                    <NavLink
                      v-if="config.user && config.user.id == user.id"
                      :link="{ path: '/manage_page_config/' + config.id, label: 'Edit', displayLabel: true, target: '_blank' }"
                      @track-link-selection="trackLinkSelection"
                      class="hover:cursor-pointer rounded-lg max-w-fit ml-1 hover:text-dark-secondary text-dark-primary underline"
                    />
                    <!-- <router-link v-if="config.user && config.user.id == user.id" target="_blank" class="hover:cursor-pointer rounded-lg max-w-fit ml-1 hover:text-dark-secondary text-dark-primary underline" :to="{path: '/manage_page_config/' + config.id}" >Edit</router-link> -->
                  </div>
                </MenuItem>
              </div>
            </div>
          </div>
          <div class="w-full" v-if="privateConfigs.length > 0">
            <div class="w-full">
              <div class="w-full p-1">
                <div class="text-sm w-full text-gray-400">Private Pages</div>
              </div>
              <div v-for="config in privateConfigs" :key="config.id" class="px-1 py-1 w-full">
                <MenuItem v-slot="{ active }" as="div">
                  <div class="flex justify-between w-full items-center">
                    <button class="flex justify-start w-full flex-nowrap" @click="setPageConfig(config)"
                      :class="[
                        active  ? 'bg-dark-primary text-white' : isSelectedConfig(config) ? 'bg-dark-primary text-white' : 'text-gray-900',
                        'rounded-md px-2 py-2 text-sm  w-full flex-nowrap '
                      ]" 
    
                    >
                      {{config.configuration_name}}
                    </button>
                    <NavLink
                      v-if="config.user && config.user.id == user.id"
                      :link="{ path: '/manage_page_config/' + config.id, label: 'Edit', displayLabel: true, target: '_blank' }"
                      @track-link-selection="trackLinkSelection"
                      class="hover:cursor-pointer rounded-lg max-w-fit ml-1 hover:text-dark-secondary text-dark-primary underline"
                    />
                    <!-- <router-link v-if="config.user && config.user.id == user.id" target="_blank" class="hover:cursor-pointer rounded-lg max-w-fit ml-1 hover:text-dark-secondary text-dark-primary underline" :to="{path: '/manage_page_config/' + config.id}" >Edit</router-link> -->
                  </div>
                </MenuItem>
              </div>
            </div>

          </div>
          <div v-if="companyAdditionalLinks && companyAdditionalLinks.length > 0">
            <div class="w-full">
              <div class="w-full p-1">
                <div class="text-sm w-full text-gray-400">Additional Links</div>
              </div>
                <div v-for="link in companyAdditionalLinks" :key="link.href" class="px-1 py-1 w-fit">
                  <MenuItem v-slot="{ active, close }" as="div">
                    <NavLink
                      @click="close"
                      :link="{ path: link.href, label: link.label, displayLabel: true }"
                      @track-link-selection="trackLinkSelection"
                      :class="[ active ? 'bg-dark-primary text-white' : 'text-gray-900', 'rounded-md px-2 py-2 text-sm  w-full flex-nowrap', ]"
                      class="flex justify-start w-full flex-nowrap"
                    />
                      <!-- <button
                        ref="button"
                        @click="close" 
                        :class="[ active ? 'bg-dark-primary text-white' : 'text-gray-900', 'rounded-md px-2 py-2 text-sm  w-full flex-nowrap', ]"
                        class="flex justify-start w-full flex-nowrap"
                      >
                          {{link.label}}
                      </button> -->
                    <!-- <router-link  class="w-full" :to="{path: link.href}" >
                    <button @click="close" class="flex justify-start w-full flex-nowrap"
                      :class="[
                        active ? 'bg-dark-primary text-white' : 'text-gray-900',
                        'rounded-md px-2 py-2 text-sm  w-full flex-nowrap',
                      ]"
                    >
                        {{link.label}}
                    </button>
                  </router-link> -->
                  </MenuItem>
              </div>
              <div class="px-1 py-1 w-fit">
                <MenuItem v-slot="{ active, close }" as="div">
                  <NavLink
                    v-if="userPermissions.isDev || userPermissions.isAccountManager || userPermissions.isManagement"
                    @click="close"
                    :link="{ path: '/create_page_config', label: 'Create New Page', displayLabel: true }"
                    @track-link-selection="trackLinkSelection"
                    :class="[ active ? 'bg-dark-primary text-white' : 'text-gray-900', 'rounded-md px-2 py-2 text-sm  w-full flex-nowrap', ]"
                    class="flex justify-start w-full flex-nowrap"
                    />
                </MenuItem>
              </div>
            </div>
          </div>

          </MenuItems>
        </transition>
      </Menu>
    </div>
  </template>
  
  <script setup>
  import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
  import { ChevronDownIcon } from '@heroicons/vue/20/solid'
  import { defineProps, defineEmits, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute, useRouter } from 'vue-router';
  import NavLink from './nav-bar-link-components/NavLink.vue';

  const props = defineProps({
    links: Array,
    companyAdditionalLinks: Array,
    pageConfigs: Array,
    userPermissions: Object,
    linkGroups: Array
    // selectedConfig: Object
  })

  const emit = defineEmits(['track-link-selection'])

  const route = useRoute()
  const router = useRouter()

  const store = useStore()

  function canViewLink(link){
    if(link.devOnly){
      return props.userPermissions.isDev 
    }
    if(link.devOrMgmt){
      return props.userPermissions.isDev || props.userPermissions.isManagement
    }
    if(link.viewPeoplePage){
      console.log("view people page", props.userPermissions.isDev || props.userPermissions.isManagement || props.userPermissions.isSuperUser || props.userPermissions.isViewUserWorkflow)
      return props.userPermissions.isDev || props.userPermissions.isManagement || props.userPermissions.isSuperUser || props.userPermissions.isViewUserWorkflow
    }
    if(link.accountingLink){
      return props.userPermissions.isDev || props.userPermissions.isManagement || store.state.auth.user.id === 69
    }
    return true
  }

  const selectedConfig = computed(() => {
    return store.getters['pageConfigs/showSelectedPageConfig']
  })

  const publicConfigs = computed(()=> {
    return props.pageConfigs.filter(config => config.is_public)
  })

  const privateConfigs = computed(()=> {
    return props.pageConfigs.filter(config => !config.is_public)
  })

  const filteredLinks = computed(() => {
    return props.links.filter((link) => {
      return canViewLink(link)
    })
  })

  function filteredGroupLinks(links) {
    return links.filter((link) => {
      return canViewLink(link)
    })
  }

  function setPageConfig(config){
    if(route.name != 'companies'){
      router.push({path:'/companies'})
        }
    store.dispatch('pageConfigs/setSelectedPageConfig', config)
    trackLinkSelection(config.configuration_name)
    }

  function isSelectedConfig(config){
    if(!selectedConfig.value){
      return false
    }
    return selectedConfig.value.id == config.id
  }

  const user = ref(store.state.auth.user)

  function trackLinkSelection(label) {
      emit("track-link-selection", label)
  }

  </script>
  